import { Stack } from "@mui/material";
import type { FC } from "react";
import { useTripTagsByCategory } from "../../orders/useTripTagsByCategory";
import SearchableMultiSelectFilter from "./SearchableMultiSelectFilter";
import { useTagParams } from "./useTagParams";

export interface Tag {
  readonly category: string;
  readonly value: string;
}

export interface PublicPackagesSearchCriteria {
  readonly tags: Tag[];
}

const TagFiltersMenu: FC = () => {
  const { tripTagsByCategory } = useTripTagsByCategory();
  const { tags: selectedTags, setTags } = useTagParams();

  return (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        flex: 1,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {Object.entries(tripTagsByCategory ?? {}).map(([category, values]) => {
        const selectedValues = selectedTags.filter((tag) => tag.category === category).map((tag) => tag.value);

        return (
          <SearchableMultiSelectFilter
            key={category}
            label={category}
            options={values.map((value) => ({ label: value, value }))}
            selectedValues={selectedValues}
            onChange={(nextValues) => {
              setTags([
                ...selectedTags.filter((tag) => tag.category !== category),
                ...nextValues.map((value) => ({ category, value })),
              ]);
            }}
          />
        );
      })}
    </Stack>
  );
};

export default TagFiltersMenu;
